module.exports = __webpack_public_path__ + "media/ecom/recomendedUpdate-1a6f9f69.svg";